import instance from "@/services/api";

export const financePaymentExcludeProjectsAPI = {
  async read(params) {
    return await instance()
      .get("/finance_payment/payment-exclude/read/", { params })
      .then((res) => res?.data);
  },

  async get(projectPaymentExcludeId) {
    return await instance()
      .get(`/finance_payment/payment-exclude/get/${projectPaymentExcludeId}/`)
      .then((res) => res?.data);
  },

  async create(payload) {
    return await instance()
      .post("/finance_payment/payment-exclude/create/", payload)
      .then((res) => res?.data);
  },

  async update(payload) {
    return await instance()
      .post("/finance_payment/payment-exclude/update/", payload)
      .then((res) => res?.data);
  },

  async delete(payload) {
    return await instance()
      .post("/finance_payment/payment-exclude/delete/", payload)
      .then((res) => res?.data);
  },
};

